export default __webpack_public_path__ + "static/media/small_business.2b07973e.svg";